module.exports = __webpack_public_path__ + "static/media/blog-hai-ask.0de5bc76.jpg";